module.exports = __webpack_public_path__ + "img/organization.42edbff9.svg";